import { useI18n } from "@/contexts/I18nContext";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  BROUILLON: "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200 border-slate-300 dark:border-slate-700",
  A_VALIDER: "bg-amber-100 text-amber-900 dark:bg-amber-950/70 dark:text-amber-200 border-amber-300 dark:border-amber-700/60",
  VALIDE: "bg-emerald-100 text-emerald-900 dark:bg-emerald-950/70 dark:text-emerald-200 border-emerald-300 dark:border-emerald-700/60",
  PUBLIE: "bg-blue-100 text-blue-900 dark:bg-blue-950/70 dark:text-blue-200 border-blue-300 dark:border-blue-700/60",
  OBSOLETE: "bg-rose-100 text-rose-900 dark:bg-rose-950/70 dark:text-rose-200 border-rose-300 dark:border-rose-700/60",
};

export const StatusBadge = ({ status }) => {
  const { t } = useI18n();
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={cn("inline-flex items-center px-2.5 py-1 rounded-md border text-xs font-semibold uppercase tracking-wide", STATUS_STYLES[status])}
    >
      {t(`statuses.${status}`)}
    </span>
  );
};
